const MESES = [
  'janeiro',
  'fevereiro',
  'março',
  'abril',
  'maio',
  'junho',
  'julho',
  'agosto',
  'setembro',
  'outubro',
  'novembro',
  'dezembro',
];

export function formatarData(iso: string): string {
  const d = new Date(iso);
  return `${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}`;
}

export function formatarPeriodo(inicio: string, fim: string): string {
  const a = new Date(inicio);
  const b = new Date(fim);
  const mesmoDia =
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  if (mesmoDia) return formatarData(inicio);

  const mesmoMes = a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear();
  if (mesmoMes) {
    return `${a.getDate()} a ${b.getDate()} de ${MESES[b.getMonth()]} de ${b.getFullYear()}`;
  }
  return `${a.getDate()} de ${MESES[a.getMonth()]} a ${b.getDate()} de ${MESES[b.getMonth()]} de ${b.getFullYear()}`;
}

export function formatarHorario(iso: string): string {
  const d = new Date(iso);
  const h = d.getHours();
  const m = d.getMinutes();
  return m > 0 ? `a partir das ${h}h${String(m).padStart(2, '0')}` : `a partir das ${h}h`;
}

export function formatarValor(centavos: number): string {
  if (centavos === 0) return 'Gratuito';
  const reais = Math.floor(centavos / 100);
  const cents = centavos % 100;
  return `R$ ${reais.toLocaleString('pt-BR')},${String(cents).padStart(2, '0')}`;
}

// Três estados do valor: pago, gratuito ou a definir.
// Quando "a definir", valor_centavos vem NULO de propósito — nunca mostre R$ 0,00.
export function textoDoValor(p: {
  valor_situacao: string;
  valor_centavos: number | null;
}): string {
  if (p.valor_situacao === 'a_definir') return 'Valor a definir';
  if (p.valor_situacao === 'gratuito') return 'Gratuito';
  return ((p.valor_centavos ?? 0) / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
}

// Frase explicativa quando as inscrições estão "em breve", conforme o motivo.
export function fraseEmBreve(motivo: string | null, abrem: string | null): string {
  if (motivo === 'valor_a_definir') {
    return 'As inscrições abrem quando a organização informar o valor.';
  }
  if (motivo === 'sem_data') {
    return 'As inscrições ainda não têm data.';
  }
  if (motivo === 'tem_data' && abrem) {
    const d = new Date(abrem);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `As inscrições abrem em ${dia}/${mes}/${ano}, às ${hh}:${mm}.`;
  }
  return 'Em breve.';
}

export function formatarDataAbertura(iso: string): string {
  const d = new Date(iso);
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  return `${dia}/${mes} às ${hora}h`;
}

export function vagasRestantes(restantes: number | null, vendeIngressos = false): string | null {
  if (restantes !== null && restantes >= 0 && restantes <= 20) {
    if (vendeIngressos) {
      return restantes === 1 ? '1 ingresso disponível' : `${restantes} ingressos disponíveis`;
    }
    return restantes === 1 ? 'Resta 1 vaga' : `Restam ${restantes} vagas`;
  }
  return null;
}